// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__o+r2B","actions":"styles_actions__npvhz","button":"styles_button__7TBF2"};